module.exports = __webpack_public_path__ + "static/img/yce-phone.3396e16.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/yce-phone.png
// module id = 370
// module chunks = 32